import React, { useEffect, useState } from 'react'
import SuperICDandCPTSearch from '../../../../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import handleNumericCheck from '../../../../../../../../../../../utils/HandleNumericKeys';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import { isSignedOrToBeCoSigned } from '../../../utils';

const ProcedureCodes = ({ children }) => {
    return (<>{children}</>)
}

const ProcedureCodesPreview = (props) => {
    const { 
    mainServiceLineModal,
    setMainServiceLineModal,
    serviceLineValidation,
    handleOnblurServiceline,
    handleServiceLineChange,
    handleDeleteRow,
    modifierBody,
    handleSuperSearchList,
    handleApplyCPTs,
    isProcedureEdit,
    CPTModal,
    cptBody,
    RecentModifiers,
    RecentCPTs,
    areAllValuesNullOrEmpty,
    handleViewClaim,
    handleCreateClaim,
    handleEditProcedure,
    handleAddNewCPT,
    isClaimViewAllowed,
    isCreateClaimEditAllowed,
    isSuperbillEditAllowed,
    dataExist,
    divClaimLinking,
    data,
    Data,
    searchParam,
    patientID,
    getSaveData,
    API_URL,
  } = props?.procedureCodesWidgetPreviewProps;
  console.log("testModal Preview")
  const API_URL_PATIENTENCOUNTER = enumUtil.controller.PatientEncounter;
  const [lastEncounterCPTs, setLastEncounterCPTs] = useState({});

  const LoadLastEncounterCPT = () => {
      if (!searchParam?.EncounterDate) return;
      setLastEncounterCPTs({});
      ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/LastEncounterCPT", 'post', {
          "TableName": enumUtil.enumAPITableName.Encounter,
          "ID": patientID,
          "SearchCriteria": {
              "EncounterDate": searchParam.EncounterDate
          }
      }).then((response) => {
          setLastEncounterCPTs({
              EncounterDate: response?.count?.EncounterDate,
              CPTs: response?.Rows || []
          });
      }).catch((error) => {});
  };

  useEffect(() => {
      if (!isNull(patientID)) {
          LoadLastEncounterCPT();
      }
  }, [patientID]);

  let isServLineUpdated = (mainServiceLineModal?.some(serviceLine => (serviceLine.isUpdated === "true")));
  let noValExistTextNA = <p className="text ar-light-color">N/A</p>;

  return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='bg_yellow p-2 w-100'>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <p className='heading font-b fs-13 mb-1 leter-spacing' id={`SuperBill-${data?.Data?.EncounterID}`}>SUPERBILL</p>
                <div className="d-flex align-items-center gap-2">
                    {!isNull(data?.Data?.EncounterID) &&
                        (!isNull(data?.Data?.ClaimID) ?
                            <div className={`d-flex align-items-center cursor-pointer ${isServLineUpdated ? 'br-right-1 br-clr pe-2' : ''} ${isClaimViewAllowed ? '' : 'disable'}`}>
                                <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                                <i className='icon-enrollment fs-13 lh-9'></i>
                            </div> :
                            (<div className={`d-flex align-items-center cursor-pointer ${isServLineUpdated ? 'br-right-1 br-clr pe-2' : ''} ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                                {(dataExist ?
                                    (divClaimLinking) :
                                    (
                                        mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                                            <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                                <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                                <i className='icon-enrollment fs-13 lh-9'></i>
                                            </div>
                                            :
                                            <></>
                                    ))}
                            </div>)
                        )}
                    <div className="d-flex">
                        {((isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus)) && isServLineUpdated) &&
                            <button className={`btn btn-orange h-100 lh-13 min-w-unset px-10 py-3px rounded ${isSuperbillEditAllowed ? '' : 'disable'}`} onClick={() => getSaveData("", "", "", 'Save Edit Superbill')}>Save</button>}
                    </div>
                </div>
            </div>

            {/* ICDs */}
            <div className="ar_content mb-2">
                <div className="d-flex align-items-center gap-1 icds-content">
                    <p className='heading pe-1'>ICD(s)</p>
                    {Data?.EncounterProblem?.length > 0 ?
                        (Data?.EncounterProblem?.map(prob => (
                            <p className='text'>{prob?.DiagnosisCode}</p>
                        ))) : noValExistTextNA}
                </div>
            </div>

            {/* Procedure Codes Header */}
            <div className="d-flex align-items-center gap-1 mb-1 justify-content-between">
                <div className='d-flex align-items-center gap-1'>
                    <p className='heading font-b fs-13 leter-spacing'>Procedure Codes</p>
                    {isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) &&
                        <>
                            <div className={isSuperbillEditAllowed ? 'd-flex' : 'disable d-flex'}>
                                {isProcedureEdit ?
                                    <i className='icon-x-cros gray-clr fw-900' onClick={handleEditProcedure}></i> :
                                    <i className='icon-Icon-material-edit ar-light-color fs-11' onClick={handleEditProcedure}></i>}
                            </div>
                        </>}
                </div>
                <div className={`d-flex align-items-center gap-1 ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                    {isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) &&
                        <>
                            <div className="all_problems-preview position-relative">
                                {lastEncounterCPTs?.CPTs?.length > 0 ?
                                    <>
                                        <p className={`text validate-color cursor-pointer user-select-none ${isProcedureEdit ? 'br-right-1 br-clr pe-2' : ''}`} onClick={handleApplyCPTs}>{lastEncounterCPTs?.EncounterDate} - CPTs</p>
                                        <div className="problem-content d-flex flex-column gap-2 hover-scrollbar ">
                                            {lastEncounterCPTs?.CPTs?.map(cpt => (
                                                <div className="d-flex align-items-center justify-content-between gap-20">
                                                    <p className="text font-m">{cpt.ProcedureCode}</p>
                                                    <p className="text font-m text-nowrap singleLine-ellispis" title={cpt?.Description}>{cpt?.Description}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </> : <></>}
                            </div>
                            {isProcedureEdit ?
                                <div className='input claims_info problems-search'>
                                    <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                                    <div className="position-relative za-denied-status Icds">
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentCPTs}
                                            placeholder={'Add Procedure'}
                                            id='ProcedureCode'
                                            name='ProcedureCode'
                                            onChange={(e) => handleServiceLineChange(e, 'data.RowID', 'index', 'ProcedureCode', 'isMainCPTEncounterSOAP')}
                                            getSelectedData={(singlerow) => handleSuperSearchList(singlerow, 'index', 'ProcedureCode', false, 'CPT')}
                                            searchValue={CPTModal.CPT}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/CPTInstantSearch"}
                                            method='post'
                                            postBody={cptBody}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, 'index')}
                                            isReadOnly={!isSuperbillEditAllowed}
                                        />
                                    </div>
                                </div> : <></>}
                        </>}
                </div>
            </div>

            {/* Table */}
            <div className="hk-expand-table overflow-auto BorderLess-table">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th className='w-212px'>Modifiers</th>
                            <th className='w-130px'>Pointers</th>
                            <th className='w-130px'>Units</th>
                            {isProcedureEdit ? <th className='w-0px'></th> : <></>}
                        </tr>
                    </thead>
                    {isProcedureEdit ?
                        <tbody>
                            <>
                                {mainServiceLineModal?.map((data, index) => {
                                    let displayProcedureCode = data?.ProcedureCode;
                                    let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index]);
                                    let amountVals = {}?.[data?.ServiceLineID];
                                    const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                                    let VISIT_PAYMENT_index = '';
                                    if (data?.Deleted !== "true") {
                                        return (
                                            <>
                                                <tr key={data.ServiceLineID}>
                                                    <td className='position-relative'>
                                                        <div className='input select-bg-img'>
                                                            {displayProcedureCode}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='hk-table-flex' >
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode1'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                                                    searchValue={data.ModifierCode1}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    placeholder={false}
                                                                    isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode2'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                                                    searchValue={data.ModifierCode2}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode3'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                                                    searchValue={data.ModifierCode3}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode4'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                                                    searchValue={data.ModifierCode4}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='hk-table-flex'>
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer1"
                                                                id="Pointer1"
                                                                maxLength={2}
                                                                value={data.Pointer1}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer2ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer2"
                                                                id="Pointer2"
                                                                maxLength={2}
                                                                value={data.Pointer2}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={
                                                                    !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer3ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer3"
                                                                id="Pointer3"
                                                                maxLength={2}
                                                                value={data.Pointer3}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={
                                                                    !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer4ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer4"
                                                                id="Pointer4"
                                                                maxLength={2}
                                                                value={data.Pointer4}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className={`form-control units unit ${!isNull(serviceLineValidation[index]?.UnitsVal) ? 'error' : ''}`}
                                                            name="Units"
                                                            id="Units"
                                                            variant="outlined"
                                                            value={data.Units}
                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                                        />
                                                    </td>
                                                    <td className='text-center'>
                                                        <span onClick={() => handleDeleteRow(index)}><i class="fs-14 icon-delete" style={{ color: 'red' }}></i></span>
                                                    </td>
                                                </tr>
                                                {CheckValidation === true ? null :
                                                    <tr>
                                                        <td colSpan={12} className='message error_message'>
                                                            {!isNull(serviceLineValidation[index]?.DOSFromVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSFromVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.DOSToVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSToVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.CPTCodeVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1Val} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1UNI} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1Val} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1UNI} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer2ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer3ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer4ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.POSVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.POSVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.UnitsVal} </p> : null}
                                                        </td>
                                                    </tr>
                                                }
                                            </>
                                        )
                                    }
                                })}
                            </>
                        </tbody> :
                        <tbody>
                            {mainServiceLineModal?.map((data, index) => {
                                let displayProcedureCode = data?.ProcedureCode;
                                if (data?.Deleted !== "true") {
                                    return (
                                        <>
                                            <tr key={data.ServiceLineID}>
                                                <td className='position-relative'>
                                                    <div className='input select-bg-img'>
                                                        {displayProcedureCode}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='hk-table-flex' >
                                                        {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                            .filter(Boolean)
                                                            .join(', ')}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='hk-table-flex'>
                                                        {[data.Pointer1, data.Pointer2, data.Pointer3, data.Pointer4]
                                                            .filter(Boolean)
                                                            .join(', ')}
                                                    </div>
                                                </td>
                                                <td>{data.Units}</td>
                                            </tr>
                                        </>
                                    )
                                }
                            })}
                        </tbody>}
                </table>
            </div>
        </div>
    </div>
  );
};

const ProcedureCodesSelectModalView = (props) => {
    const {
    Data,
  } = props?.procedureCodesWidgetPreviewProps;

//   console.log("testModal SelectModal")
let noValExistText = <p className="text ar-light-color">No data recorded</p>;
  return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className="d-flex flex-column gap-6 w-100">
            <div className="d-flex">
                <p class="text fs-14 font-b validate-color blue-bg">Procedure Codes</p>
            </div>
            {Data?.mainServiceLineModal?.length > 0 ?
                <div className="d-flex flex-column gap-1">
                    {Data.mainServiceLineModal.map((data) => {
                        let modifiersExists = [data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4].filter(Boolean)?.length > 0;
                        return (
                            <div className="d-flex align-items-center gap-1 flex-wrap">
                                <p className='text font-m validate-color'>{data?.ProcedureCode}</p>
                                {data?.ProcedureDescription ? <p className="text text-black">{data?.ProcedureDescription && `- ${data.ProcedureDescription}`}</p> : null}
                                {modifiersExists ?
                                    (<div className="d-flex align-items-center gap-1">
                                        <p className="text text-black font-m">Modifiers:</p>
                                        <p className="heading text-black">
                                            {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                .filter(Boolean).join(', ')}
                                            {data?.Units && !['1', 1, '1.00'].includes(data.Units) && ', '}
                                        </p>
                                    </div>) : <></>}
                                {((data?.Units) && !['1', 1, "1.00"].includes(data.Units)) ?
                                    (<div className="d-flex align-items-center gap-1">
                                        <p className="text text-black font-m">Units:</p>
                                        <p className="heading text-black">
                                            {data?.Units}
                                        </p>
                                    </div>) : <></>}
                            </div>
                        )
                    }
                    )}
                </div> :
                <>{noValExistText}</>}

        </div>
    </div>
  );
};

ProcedureCodes.Preview = ProcedureCodesPreview 
ProcedureCodes.SelectModalView = ProcedureCodesSelectModalView

export default ProcedureCodes;